import { OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

export class CoreComponent implements OnDestroy {
  protected ngUnsubscribe = new Subject<void>();

  // subscriptions to unsubscribe
  protected subscription: Subscription = new Subscription();

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
